export class GlobalService {
    baseUrl = 'https://rinnolab.cl/';
    siteKey = '6LeP04AUAAAAAPnxknn2SraZj-pS5hUyjzo1DxgT';
    //siteKey = '6Ldx19EZAAAAAFNBbwObIIAMbQLjpxqyAA_cI9cH';
    //siteKey = '6Ldx19EZAAAAAOM-JM5eii3kY3Pk6yH_2NZOwUiG';
}
